import { spacing, style, typography } from '@material-ui/system'
import { palette } from '@procurify/ui-theme'
import styled, { css } from 'styled-components'

import { SubheaderStyled } from './SubheaderStyled'
import { type IHeaderProps } from '../Header'

// The theme's heading style. Header only ever passes an h1-h5 key: style()
// writes a key the theme lacks (such as `span`) verbatim into the CSS, which
// invalidates the declaration that follows it.
const headingStyle = style({
  cssProperty: false,
  prop: '$headingStyle',
  themeKey: 'typography',
})

interface IHeaderStyledProps extends IHeaderProps {
  $headingStyle?: IHeaderProps['variant']
}

const HeaderStyled = styled.h1<IHeaderStyledProps>`
  margin: 0;

  ${(props) =>
    props.as === 'span' &&
    css`
      display: block;
    `}

  ${(props) =>
    props.$headingStyle === 'h5' &&
    css`
      ${SubheaderStyled} {
        font-size: ${props.theme.typography.pxToRem(14)};
      }
    `}

  && {
    ${(props) => {
      if (props.gutter) {
        return `margin-bottom: 1em;`
      }
    }}

    ${(props) => {
      if (props.icon) {
        return css`
          text-align: center;
        `
      }
    }}
  }

  ${headingStyle}
  ${typography}
  ${spacing}
  ${palette}
`

HeaderStyled.defaultProps = {
  as: 'h1',
}

export { HeaderStyled }
